module.exports = __webpack_public_path__ + "img/SaveImage.6ea88e1f.svg";